import { createClient } from '@supabase/supabase-js'

// CRA exposes env vars via process.env and requires the REACT_APP_ prefix
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase env vars missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in a .env file and restart the dev server.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
